import { useEffect } from 'react'
import { getUnReadCount } from '@/services/pns.ts'
import { useSetState } from 'ahooks'
import { exportDownCount } from '@/services'

export default function useUnReadCount(countKeys: string[] = ['messageCount']) {
  const [state, setState] = useSetState({
    messageCount: 0,
    downloadCount: 0,
  })

  const fetchReadCount = () => {
    getUnReadCount({}).then(res => {
      setState({
        messageCount: parseInt(res as string),
      })
    })
  }

  useEffect(() => {
    if (countKeys.includes('messageCount')) {
      fetchReadCount()
    }

    if (countKeys.includes('downloadCount')) {
      exportDownCount().then(res => {
        setState({
          downloadCount: parseInt(res as string),
        })
      })
    }

    window.addEventListener('UPDATE_MESSAGE_COUNT', fetchReadCount)

    return () => {
      window.removeEventListener('UPDATE_MESSAGE_COUNT', fetchReadCount)
    }
  }, [])

  return [state]
}
